// src/services/kassaService.js
import axiosClient from "../axiosClient";

const route = "kassa";
const kassaTransRoute = "kassaTransaction";

// Get all Kassas with pagination and search
export const getAllKassas = async (params) => {
  try {
    const response = await axiosClient.get(`${route}/getAll`, {
      params,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// Create a new Kassa
export const createKassa = async (kassaData) => {
  try {
    const response = await axiosClient.post(`${route}`, kassaData);
    return response;
  } catch (error) {
    throw error;
  }
};

// Update an existing Kassa
export const updateKassa = async (kassaId, updateData) => {
  try {
    const response = await axiosClient.put(`${route}/${kassaId}`, updateData);
    return response;
  } catch (error) {
    throw error;
  }
};

// Delete a Kassa
export const deleteKassa = async (kassaId) => {
  try {
    const response = await axiosClient.delete(`${route}/${kassaId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

// Get a specific Kassa by ID
export const getKassaById = async (kassaId, params) => {
  try {
    const response = await axiosClient.get(`${kassaTransRoute}/${kassaId}`, {
      params,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const createKassaTransaction = async (transactionData) => {
  try {
    const response = await axiosClient.post(
      `${kassaTransRoute}`,
      transactionData
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateKassaTransaction = async (kassaTransId, updateData) => {
  try {
    const response = await axiosClient.put(
      `${kassaTransRoute}/${kassaTransId}`,
      updateData
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteKassaTransaction = async (kassaTransId) => {
  try {
    const response = await axiosClient.delete(
      `${kassaTransRoute}/${kassaTransId}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};
